import { motion } from 'framer-motion';
import MotionImage from '../AnimatedImage';
import Image from 'next/image';

const imageReveal = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { ease: [0, 1, 1, 1], duration: 0.8 },
  },
};

const imageVariants = {
  initial: {
    scale: 1,
    transition: { type: 'spring', damping: 65, stiffness: 1000, mass: 1, restDelta: 0.000001 },
  },
  hover: {
    scale: 1.04,
    transition: { type: 'spring', damping: 65, stiffness: 1000, mass: 1, restDelta: 0.000001 },
  },
};

export interface SingleImageBlockProps {
  image: any;
  image_description?: string;
  border_radius?: string;
  hover?: boolean;
  no_motion?: boolean;
  force_aspect?: string;
  image_class?: string;
  caption_class?: string;
}

export function SingleImageBlock({
  image,
  image_description,
  border_radius,
  hover,
  no_motion,
  force_aspect,
  image_class,
  caption_class,
}: SingleImageBlockProps) {
  const hasDims = image && Number.isFinite(Number(image.width)) && Number.isFinite(Number(image.height));

  if (!image?.src) return null;

  const imageClass = image_class ? image_class : 'object-contain object-left';

  const singleimage = (
    <motion.div
      className={`relative w-full overflow-hidden ${border_radius ? border_radius : 'rounded'}`}
      style={
        force_aspect
          ? ({
              aspectRatio: force_aspect,
            } as React.CSSProperties)
          : hasDims
          ? ({
              aspectRatio: `${image.width} / ${image.height}`,
            } as React.CSSProperties)
          : ({ minHeight: 180 } as React.CSSProperties)
      }
    >
      {no_motion ? (
        <Image src={image.src} alt={image.alt ?? ''} fill className={imageClass} sizes={'(max-width: 768px) 100vw, (max-width: 1600px) 60vw, 40vw'} priority />
      ) : (
        <MotionImage
          variants={hover ? imageVariants : undefined}
          whileHover={hover ? 'hover' : undefined}
          src={image.src}
          alt={image.alt ?? ''}
          fill
          className={imageClass}
          sizes={'(max-width: 768px) 100vw, (max-width: 1600px) 60vw, 40vw'}
          priority
        />
      )}
    </motion.div>
  );

  return image_description ? (
    <motion.div
      className="flex h-full w-full flex-col gap-4"
      variants={no_motion ? undefined : imageReveal}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.6 }}
    >
      {singleimage}
      <motion.div className={`type-caption-press ${caption_class || ''}`} dangerouslySetInnerHTML={{ __html: image_description }} />
    </motion.div>
  ) : (
    singleimage
  );
}
